import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Testimonial from './Pages/Testimonial';
import Portfolio from './Pages/Portfolio';
import Test from './Pages/Test';
import Test1 from './Components/Framer/index';
import Bubble from './Pages/Bubble';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/Test" element={<Test1 />} />
                <Route path="/About" element={<About />} />
                <Route path="/Service/:id" element={<Services />} />
                <Route path="/Testimonial" element={<Testimonial />} />
                <Route path="/Portfolio" element={<Portfolio />} />
                <Route path='/' element={<Test />} />
                <Route path='/Bubble' element={<Bubble />} />
            </Routes>
        </BrowserRouter>

    );
}

export default App;
